import React, { useEffect, useState } from "react";
import { api, dateFormat, euroFormat, formatApiErrorDetail } from "../../lib/api";
import ExportButton from "../../components/ExportButton";

export default function Provisionen() {
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState("");
  const load = () => api.get("/admin/provisionen").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const gutschrift = async (pid) => {
    try {
      const r = await api.post(`/admin/provisionen/${pid}/gutschrift`);
      setMsg(`Gutschrift ${r.data.nummer} erstellt.`);
      load();
    } catch (e) {
      setMsg(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="space-y-5" data-testid="provisionen-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <h1 className="text-3xl font-heading font-bold text-falke-blue">Provisionsauszahlungen</h1>
        <ExportButton endpoint="/admin/exports/provisionen" defaultFilename="Provisionen.csv" label="Provisionen-Export" testId="export-provisionen" />
      </div>
      {msg && <div className="text-sm text-falke-success" data-testid="prov-msg">{msg}</div>}
      {items.length === 0 ? (
        <div className="falke-card p-10 text-center text-falke-anthracite/60">Keine Provisionen.</div>
      ) : (
        <div className="falke-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-falke-blue/70 text-xs uppercase tracking-wider border-b border-falke-blue/10">
              <tr>
                <th className="px-4 py-3">Datum</th><th>Tippgeber</th><th>Auftragswert</th><th>Satz</th><th>Provision (netto)</th><th>Status</th><th>Aktion</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-falke-blue/5" data-testid={`prov-${p.id}`}>
                  <td className="px-4 py-3">{dateFormat(p.erstellt_am)}</td>
                  <td>{p.tippgeber_name}</td>
                  <td className="tabular">{euroFormat(p.auftragswert_netto)}</td>
                  <td className="tabular">{(p.provisionssatz * 100).toFixed(0)} %</td>
                  <td className="tabular font-bold text-falke-orange">{euroFormat(p.provisionsbetrag_netto)}</td>
                  <td><span className="status-badge bg-falke-blue/10 text-falke-blue">{p.status}</span></td>
                  <td>
                    {p.status === "offen" && (
                      <button onClick={() => gutschrift(p.id)} className="text-falke-orange font-semibold text-sm hover:underline" data-testid={`make-gs-${p.id}`}>Gutschrift erstellen</button>
                    )}
                    {p.gutschrift_id && <span className="text-falke-success text-sm">✓ Gutschrift</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
